module.exports = __webpack_public_path__ + "static/img/logo-morrision-hershfield.615136d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/complete/logo-morrision-hershfield.png
// module id = ALNS
// module chunks = 0